import axios from "axios";

export const clientePedido = axios.create({
  // baseURL: "http://localhost:55000/"
  //baseURL: "http://localhost:8088/" //deploy de test en servidor PRODUCCION
  //baseURL: "http://10.2.0.51:52913/"
  // baseURL: "https://172.16.1.44:20004/" // TEST
  baseURL: "https://web.colvennet.com:20003/"
  //baseURL: "http://10.1.0.9:2003/"
});

// agrego el header de autorización a pedidos
clientePedido.interceptors.request.use(
  function(config) {
    // recupero el token de seguridad
    let token = JSON.parse(localStorage.getItem("SistemaPedidoToken"));

    // agrego el header
    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = "Bearer " + btoa(token.Sesion);
    }

    return config;
  },
  function(error) {
    return Promise.reject(error);
  }
);

export const garantia = axios.create({
  // baseURL: "http://localhost:54148/"
  //baseURL: "https://localhost:20002/" //deploy de test en servidor PRODUCCION
  // baseURL: "https://172.16.1.44:20002/" // TEST
  baseURL: "https://web.colvennet.com:20002/"
  //baseURL: "http://10.1.0.9:2002/"
});

// agrego el header de autorización a garantía
garantia.interceptors.request.use(
  function(config) {
    // recupero el token de seguridad
    let token = JSON.parse(localStorage.getItem("SistemaPedidoToken"));

    // agrego el header
    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = "Bearer " + btoa(token.Sesion);
    }

    return config;
  },
  function(error) {
    return Promise.reject(error);
  }
);

// NOTA: en el archivo main.js hay un interceptor para el manejo de errores
